<template>
  <div>
    <div
      class="apply-menu-wrap1"
      :style="[classList.length > 1 ? { display: 'none' } : {}]"
    >
      <div class="top-menu">
        <h1>
          <div
            v-if="
              logo !== '' &&
              logo !== 'null' &&
              logo !== 'undefined' &&
              logo !== null
            "
          >
            <img :src="logo" alt="company logo" style="height: 20px" />
          </div>
          <div v-else alt="company logo" style="height: 20px" />
          <span v-if="mainTitle !== ''" class="whitespace-nowrap">{{
            mainTitle
          }}</span>
          <span v-else>사내어학클래스</span>
        </h1>
        <!-- 모바일용 -->
        <a class="m-menu" id="header-menu-btn">
          <img
            @click="openMenu()"
            class="pointer"
            src="../../assets/img/m_menu.png"
            alt="menu"
          />
        </a>
        <ul>
          <!-- 여기 display none 풀기 -->
          <li :class="setColor()">
            <a>신청하기</a>
          </li>
          <li v-if="isRegUser == 'Y'">
            <a class="pointer" @click="moveMobileApplyList()">신청내역 확인</a>
          </li>
          <li>
            <a class="pointer" @click="logoutMobile()">Logout</a>
          </li>
        </ul>
      </div>
      <!-- 반응형 메뉴 -->
      <div class="m-top-menu" id="select-header-menu" style="display: none">
        <a class="close" id="header-close" @click="closeMenu()">
          <img class="pointer" src="../../assets/img/close.png" alt="close" />
        </a>

        <ul class="clear">
          <li><a :class="setColor()">신청하기</a></li>
          <li v-if="isRegUser == 'Y'">
            <a class="pointer" @click="moveMobileApplyList()">신청내역 확인</a>
          </li>
          <!-- <li><a class="pointer" @click="moveFixPW()">비밀번호 재설정</a></li> -->
          <li><a class="pointer" @click="logoutMobile()">Logout</a></li>
        </ul>
      </div>
    </div>
    <!-- 등록 갯수가 2개 이상일 때 노출  -->
    <div
      class="apply-menu-wrap1"
      :style="[classList.length <= 1 ? { display: 'none' } : {}]"
    >
      <div class="top-menu">
        <h1>
          <div
            v-if="
              logo !== '' &&
              logo !== 'null' &&
              logo !== 'undefined' &&
              logo !== null
            "
          >
            <img :src="logo" alt="company logo" style="height: 20px" />
          </div>
          <div v-else alt="company logo" style="height: 20px" />
          <span v-if="mainTitle !== ''" class="whitespace-nowrap">{{
            mainTitle
          }}</span>
          <span v-else>사내어학클래스</span>
        </h1>
        <a class="m-menu" id="header-menu-btn">
          <img
            @click="openMenuSub()"
            class="pointer"
            src="../../assets/img/m_menu.png"
            alt="menu"
          />
        </a>
        <ul>
          <li :class="setColor()">
            <a class="pointer" @click="moveReg()">신청하기</a>
          </li>
          <li v-if="isRegUser == 'Y'">
            <a class="pointer" @click="moveApplyList()">신청내역 확인</a>
          </li>
          <li>
            <a class="pointer" @click="logout()">Logout</a>
          </li>
        </ul>
      </div>
      <!-- 반응형 메뉴 -->
      <div class="m-top-menu" id="select-header-menu-sub" style="display: none">
        <a class="close" id="header-close" @click="closeMenuSub()">
          <img src="../../assets/img/close.png" alt="close" />
        </a>

        <ul class="clear">
          <li><a :class="setColor()">신청하기</a></li>
          <li v-if="isRegUser == 'Y'">
            <a class="pointer" @click="moveMobileApplyList()">신청내역 확인</a>
          </li>
          <!-- <li><a class="pointer" @click="moveFixPW()">비밀번호 재설정</a></li> -->
          <li><a class="pointer" @click="logoutMobile()">Logout</a></li>
        </ul>
      </div>
    </div>

    <div class="con">
      <!--  PC용 타이틀 부분-->
      <div class="title-pc">
        <div class="title">
          <h2>{{ program.program_name }}</h2>
          <span
            class="all-program float-left pointer"
            :class="setColor()"
            @click="openPopup()"
            >전체클래스 상세보기</span
          >
          <p><br /></p>
        </div>
        <progress-bar></progress-bar>
      </div>
      <!--  PC용 타이틀 부분 end -->
      <!--  태블릿용 타이틀 부분-->
      <div class="title-tablet">
        <div class="title">
          <h2>{{ program.program_name }}</h2>
          <span
            class="all-program pointer float-right"
            :class="setColor()"
            @click="openPopup()"
            >전체클래스 상세보기</span
          >
        </div>
        <div class="apply-class">
          <ul>
            <li
              class="pointer"
              :class="setTabColor(item.idx)"
              v-for="(item, index) of classList"
              :key="index"
              @click="selectClass(item.idx, index)"
            >
              <a>{{ item.class_name }}</a>
            </li>
          </ul>
        </div>
        <progress-bar></progress-bar>
      </div>
      <!--  태블릿용 타이틀 부분 end -->
      <!--  모바일용 타이틀 부분-->
      <div class="title-mobile">
        <div class="title">
          <h2>{{ program.program_name }}</h2>
          <p></p>
          <span
            class="all-program pointer"
            :class="setColor()"
            @click="openPopup()"
            >전체클래스 상세보기</span
          >
        </div>

        <progress-bar></progress-bar>
        <div class="apply-class">
          <ul>
            <li
              class="pointer"
              :class="setTabColor(item.idx)"
              v-for="(item, index) of classList"
              :key="index"
              @click="selectClass(item.idx, index)"
            >
              <a>{{ item.class_name }}</a>
            </li>
          </ul>
        </div>
      </div>
      <!--  모바일용 타이틀 부분 end -->

      <div class="mt-50">
        <div class="apply-program-wrap">
          <div class="apply-program">
            <!-- 강의 검색이 있을 경우 -->
            <div class="apply-program-search" v-if="isSearch == 'Y'">
              <div class="search-div">
                <span class="search-div1">
                  <span
                    class="toggle pointer search_box"
                    :class="setColor()"
                    v-if="searchBoxOn === false"
                    @click="searchBoxOn = true"
                    >강의 검색<span class="top">∧</span></span
                  >
                  <span
                    class="toggle pointer search_box"
                    :class="setColor()"
                    v-else-if="searchBoxOn === true"
                    @click="searchBoxOn = false"
                    >강의 검색 <span class="bottom">∨</span>
                  </span>
                </span>

                <div class="tablet"></div>

                <span class="search-div2">
                  <span v-if="searchBoxOn === false"
                    >특정 조건을 검색하시려면 검색 박스를 클릭 해주세요</span
                  >
                  <span v-else
                    >원하시는 강의 선택을 위해 검색 조건을 설정해주세요.</span
                  >
                </span>

                <div class="mobile"></div>
                <span class="search-div3" v-if="searchBoxOn === true">
                  <input
                    type="checkbox"
                    class="checkbox"
                    v-model="end"
                    true-value="Y"
                    false-value=""
                    name=""
                    id=""
                  />
                  <span>마감된 클래스 제외</span>
                  <button @click="searchClass()" class="search-btn">
                    검색
                  </button>
                </span>
              </div>
              <div v-if="searchBoxOn === true" class="search">
                <ul v-if="isEmptyItem(language)">
                  <li class="search-title">언어</li>
                  <li v-for="(item, index) of language" :key="index">
                    <label :for="item.key" class="mt--10">
                      <input
                        type="checkbox"
                        class="mr-05"
                        :value="item.key"
                        name="language"
                        :id="item.value"
                        v-model="searchObject.language"
                      />
                      <span class="mr-05" :for="item.key">{{ item.key }}</span>
                    </label>
                  </li>
                </ul>
                <ul v-if="isEmptyItem(place)">
                  <li class="search-title">장소</li>
                  <li v-for="(item, index) of place" :key="index">
                    <label :for="item.key" class="mt--10">
                      <input
                        type="checkbox"
                        class="mr-05"
                        v-model="searchObject.place"
                        :value="item.key"
                        name="place"
                        :id="item.key"
                      />
                      <span class="mr-05">{{ item.key }}</span>
                    </label>
                  </li>
                </ul>
                <ul v-if="columnOrders.includes('교육시간')" class="mt-05">
                  <li class="search-title">시작시간</li>

                  <li v-for="(item, index) of previewTimeList" :key="index">
                    <label :for="item" class="mt--10">
                      <input
                        type="checkbox"
                        class="mr-02"
                        :value="item"
                        name="subjectStartTime"
                        v-model="searchObject.time"
                      />
                      <span class="mr-05"> {{ item }} </span>
                    </label>
                  </li>
                </ul>

                <ul v-if="isEmptyItem(previewWeek)">
                  <li class="search-title">요일</li>
                  <li v-for="(item, index) of previewWeek" :key="index">
                    <label :for="item" class="mt--10">
                      <input
                        type="checkbox"
                        class="mr-02"
                        :value="item"
                        name="day"
                        v-model="searchObject.weekday"
                      />
                      <span class="mr-05">
                        {{ item.replace(/\^/gi, "") }}
                      </span>
                    </label>
                  </li>
                </ul>
                <ul v-if="isEmptyItem(teacher)" class="item-div clear">
                  <li class="search-title">강사</li>
                  <li v-for="(item, index) of teacher" :key="index">
                    <label :for="item.key" class="mt--10">
                      <input
                        type="checkbox"
                        class="mr-02"
                        v-model="searchObject.teacher"
                        :id="item.key"
                        :value="item.key"
                        name="teacher"
                      />
                      <span class="mr-05"> {{ item.key }} </span>
                    </label>
                  </li>
                </ul>
                <ul v-if="isEmptyItem(level)" class="item-div clear">
                  <li class="search-title">레벨</li>
                  <li v-for="(item, index) of level" :key="index">
                    <label :for="item.key" class="mt--10">
                      <input
                        type="checkbox"
                        class="mr-02"
                        v-model="searchObject.level"
                        :id="item.key"
                        :value="item.key"
                        name="level"
                      />
                      <span class="mr-05"> {{ item.key }} </span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>

            <!-- 선착순 표기 div -->
            <div class="limit-title">
              <div class="limit-text bold">학습강좌</div>

              <!-- 프로그램 선착순 -->
              <div class="limit-program">
                <span v-if="main.limit_way === 'P'">
                  <span v-if="totalWaitStudentCnt >= 0"
                    >신청 인원: {{ totalStudent }}/{{
                      main.limit_num
                    }}명&nbsp;&nbsp;|&nbsp;&nbsp;</span
                  >
                </span>
                <span
                  v-if="
                    main.limit_way === 'P' &&
                    main.wait_YN === 'Y' &&
                    is_wait_show == true &&
                    main.wait_num_YN === 'Y'
                  "
                >
                  <span v-if="totalWaitStudentCnt >= 0"
                    >대기 인원: {{ totalWaitStudentCnt }}/{{
                      main.wait_num
                    }}명</span
                  >
                </span>
              </div>
              <!-- 프로그램 선착순 end -->

              <div class="limit-class">
                <!-- 클래스 전체가 선착순일 경우 -->
                <span v-if="faMain.waitingNum > 0"></span>
                <span v-if="faMain.faType === 'AF' && searchOption != -999">
                  <span
                    >모집 : {{ faMain.faNum }}명&nbsp;&nbsp;|&nbsp;&nbsp;
                  </span>
                  <span v-if="faMain.restYn === 'Y'"
                    >잔여 :
                    <span v-if="faMain.faNum - applyCountNum >= 0"
                      >{{ faMain.faNum - applyCountNum }}
                    </span>
                    <span v-else>0</span>명
                    <span v-if="main.wait_num_YN === 'Y'">| </span>&nbsp;&nbsp;
                  </span>
                  <span>
                    <span
                      v-if="
                        faMain.waitingNum !== 0 &&
                        waitCountNum < faMain.waitingNum
                      "
                    >
                      대기 신청 가능
                      <span v-if="main.wait_num_YN === 'Y'">
                        (잔여: {{ faMain.waitingNum - waitCountNum }}명)
                      </span>
                    </span>
                    <span v-else-if="faMain.waitingNum !== 0">
                      대기인원 마감
                      <span v-if="main.wait_num_YN === 'Y'">
                        (잔여: {{ faMain.waitingNum - waitCountNum }}명)
                      </span>
                    </span>
                    <span v-else>대기 신청 불가능</span>
                  </span>
                </span>
                <!-- 클래스 전체가 선착순일 경우 finish -->
              </div>
            </div>

            <div class="limit-contents">
              <p>
                * 수강신청 완료 후 반드시 수강신청내역 확인을 진행해주시기
                바랍니다.<br />
                * 수강 취소를 원하시는 경우 수강신청 내역 확인 메뉴에서
                진행해주시기 바랍니다.<br />
              </p>
            </div>

            <!-- 강의 검색이 있을 경우 finish -->
            <div class="search-option">
              <select
                v-model="searchOption"
                class="w-75px"
                @change="selectOption($event)"
              >
                <option
                  v-for="(item, index) of classList"
                  :key="index"
                  :value="item.idx"
                  selected="selected"
                >
                  {{ item.class_name }}
                </option>
              </select>
              <span class="text">
                * 왼쪽 화살표(<img src="../../assets/img/check_red.png" />)를
                눌러 세부 강의를 확인해보세요.
              </span>
            </div>
            <div class="text-mobile">
              * 위의 화살표(<img src="../../assets/img/check_red.png" />)를 눌러
              세부 강의를 확인해보세요.
            </div>

            <!-- select 리스트 new-->
            <div class="select-div">
              <div
                class="select-wrap"
                v-for="(item, index) of sugangList"
                :key="index"
                :class="setColorByItem(item.checked)"
              >
                <div
                  v-if="item.notValid === true || checkBlock(item)"
                  class="program-close"
                >
                  <div>
                    <span :class="setColorByItem(item.checked)">
                      <!-- v-model="selectList[classNum][index]" -->
                      <!-- <input type="checkbox" disabled @click="checkedItem(item)" v-model="selectList[classNum][index]" name="" id="" /> -->
                    </span>
                    <span v-if="item.faNum !== 0 && item.faType === 'SF'">
                      <span class="select-btn-default">
                        모집 : {{ item.faNum }}
                      </span>
                      <span v-if="item.restYn === 'Y'" class="select-btn-red">
                        잔여 : {{ item.faNum - item.applicantNum }}
                      </span>

                      <span v-if="main.wait_num_YN === 'Y'">
                        <span
                          v-if="
                            item.waitingNum !== 0 &&
                            item.statusYCnt < item.waitingNum
                          "
                          class="select-btn-default"
                        >
                          대기 신청 가능
                          <span v-if="main.wait_num_YN === 'Y'">
                            (잔여: {{ item.waitingNum - item.statusYCnt }}명)
                          </span>
                        </span>
                        <span
                          v-else-if="item.waitingNum !== 0"
                          class="select-btn-default"
                        >
                          대기인원 마감
                          <span v-if="main.wait_num_YN === 'Y'"
                            >(잔여: {{ item.waitingNum - item.statusYCnt }}명)
                          </span>
                        </span>
                        <span v-else class="select-btn-default"
                          >대기 신청 불가능
                        </span>
                      </span>

                      <br />
                      <span
                        class="select-title2"
                        @click="openModal(item)"
                        :class="setColorByItem(item.checked)"
                      >
                        {{ item.subjectName }}
                      </span>
                    </span>
                    <span
                      v-else
                      class="select-title"
                      @click="openModal(item)"
                      :class="setColorByItem(item.checked)"
                    >
                      {{ item.subjectName }}
                    </span>
                    <br />
                  </div>

                  <div>
                    <button @click="openModal(item)" class="open-btn">
                      자세히보기
                    </button>
                  </div>
                  <div class="select-text">
                    <div>
                      <span
                        v-for="(item, index) of viewItemList(item)"
                        :key="index"
                      >
                        {{ item.key || "-" }} : {{ item.value || "-" }} |
                      </span>
                      <span v-if="is_num == 'Y'">
                        신청인원{{ item.applicantNum }} 명
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  v-else
                  class="program-info"
                  :class="{ 'program-select blue': item.selected }"
                >
                  <div>
                    <span :class="setColorByItem(item.checked)">
                      <!-- v-model="selectList[classNum][index]" -->

                      <input
                        type="checkbox"
                        @click="checkedItem(item)"
                        v-model="selectList[classNum][index]"
                        name=""
                        id=""
                      />
                    </span>
                    <span v-if="item.faNum !== 0 && item.faType === 'SF'">
                      <span class="select-btn-default">
                        모집 : {{ item.faNum }}
                      </span>
                      <span v-if="item.restYn === 'Y'" class="select-btn-red">
                        잔여 : {{ item.faNum - item.applicantNum }}
                      </span>
                      <span>
                        <span
                          v-if="
                            item.waitingNum !== 0 &&
                            item.statusYCnt < item.waitingNum
                          "
                          class="select-btn-default"
                        >
                          대기 신청 가능
                          <span v-if="main.wait_num_YN === 'Y'">
                            (잔여: {{ item.waitingNum - item.statusYCnt }}명)
                          </span>
                        </span>
                        <span
                          v-else-if="item.waitingNum !== 0"
                          class="select-btn-default"
                        >
                          대기인원 마감
                          <span v-if="main.wait_num_YN === 'Y'">
                            (잔여: {{ item.waitingNum - item.statusYCnt }}명)
                          </span>
                        </span>
                        <span v-else class="select-btn-default"
                          >대기 신청 불가능
                        </span>
                      </span>

                      <br />
                      <span
                        class="select-title2"
                        @click="openModal(item)"
                        :class="setColorByItem(item.checked)"
                      >
                        {{ item.subjectName }}
                      </span>
                    </span>
                    <span
                      v-else
                      class="select-title"
                      @click="openModal(item)"
                      :class="setColorByItem(item.checked)"
                    >
                      {{ item.subjectName }}
                    </span>
                    <br />
                  </div>

                  <div>
                    <button @click="openModal(item)" class="open-btn">
                      자세히보기
                    </button>
                  </div>
                  <div class="select-text">
                    <div>
                      <span
                        v-for="(item, index) of viewItemList(item)"
                        :key="index"
                      >
                        {{ item.key || "-" }} : {{ item.value || "-" }} |
                      </span>
                      <span v-if="is_num == 'Y'">
                        신청인원{{ item.applicantNum }} 명
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="apply-result">
            <div class="result-div1">
              <div class="result-title">선택 내역</div>
              <div v-if="paymentList.length > 0" class="result-contents">
                <span v-for="(item, index) of paymentList" :key="index">
                  <span v-if="index > 0">/ </span>{{ item.subjectName }}
                </span>
              </div>
              <div v-else class="result-contents">
                <span> 학습강좌를 선택해주세요. </span>
              </div>
            </div>
            <div class="result-div2">
              <button class="apply-btn" :class="setColor()" @click="apply()">
                수강신청
              </button>
              <span class="apply-text" v-if="totalPayment != 0"
                >{{ numberFormat(totalPayment) }}원</span
              >
            </div>
          </div>

          <div class="apply-result-mobile">
            <div class="result-div1">
              <span class="text">선택 내역</span>
            </div>
            <div class="result-div2">
              <span>
                <span v-if="paymentList.length > 0" class="text">
                  <span v-for="(item, index) of paymentList" :key="index">
                    <span v-if="index > 0">/</span>{{ item.subjectName }}
                  </span>
                </span>
                <span v-else class="text"> 학습강좌를 선택해주세요. </span>
              </span>
            </div>
            <div class="result-div3" v-if="totalPayment != 0">
              <span class="text">{{ numberFormat(totalPayment) }}원</span>
            </div>
            <div class="result-div4" :class="setColor()" @click="apply()">
              <span>수강신청</span>
            </div>
          </div>
        </div>
        <detail-process
          v-if="isDetailModalOpened"
          :parentData="parentData"
          @close="closeModal()"
        ></detail-process>
      </div>
    </div>
  </div>
</template>

<script>
import DetailProcess from "@/components/reg/select/detailModal.vue";
import _ from "lodash";
export default {
  components: {
    DetailProcess,
  },
  data: () => ({
    totalWaitStudentCnt: 0,
    isBlocked: false,
    isDetailModalOpened: false,
    isSearch: "",
    classIdx: 0, // 현재 선택된 클래스 아이디
    programIdx: sessionStorage.getItem("programIdx"), // 프로그램 idx
    classNum: 0, // 현재 선택된 클래스 순서번호
    searchOption: -999,
    logo: "",
    mainTitle: "",
    previewTimeList: [],
    searchObject: {
      language: [],
      place: [],
      time: [],
      weekday: [],
      teacher: [],
      level: [],
    },

    // 언어 검색 쿼리
    language: [],
    place: [],

    time: [],
    weekday: [],
    teacher: [],
    level: [],

    subjectTime: [
      {
        key: "오전",
        value: false,
      },
      {
        key: "점심",
        value: false,
      },
      {
        key: "저녁",
        value: false,
      },
    ],

    day: [
      {
        key: "월",
        value: false,
      },
      {
        key: "화",
        value: false,
      },
      {
        key: "수",
        value: false,
      },
      {
        key: "목",
        value: false,
      },
      {
        key: "금",
        value: false,
      },
      {
        key: "토",
        value: false,
      },
      {
        key: "일",
        value: false,
      },
    ],

    // 선착순, 잔여, 대기자 정보
    faMain: {
      value: false,
      faNum: 0,
      faType: "N",
      watingNum: "", // 대기자 계산
      restYn: "", // 잔여인원 표시여부
      applicantNum: "", // 신청자수
    },

    // 쿼리로 검색할때 faType이 AF인 경우 검색없는경우 백업했다가 다시출력
    backUpFaMain: "",
    isBeforeListZero: false,
    columnOrders: [], // 노출 컬럼 순서
    main: {},
    program: {}, // 프로그램 옵션 데이터
    classList: [], // 과목명 리스트
    subjectAllList: [], // 프로그램 전체 수업 리스트
    subjectList: [], // 한 과목의 수업 리스트
    sugangList: [], // 수강 신청 리스트
    selectedList: [], // 선택된 수강 신청 index

    paymentList: [], // 구매할 수강 내역
    totalPayment: 0, // 총 금액
    firstWatch: true,

    parentData: {}, // 레이어팝업에 전달할 해당 강의 데이터
    isFinishPage: false, // 현재 페이지가 마지막 페이지인지
    isRegPage: false, // 현재 페이지가 신청완료 직전 페이지인지
    changeClass: false, // 클래스 변경중인지 아닌지
    studentSubjectList: [],
    selectList: [],

    applyCountNum: 0,
    waitCountNum: 0,
    checkBoxCheckNum: 0,
    applyWaitCountNum: 0,

    partial_pay: "A",

    end: "",

    pointColor: "blue",

    searchBoxOn: true,
    is_view: "N",
    is_num: "N",
    is_pay: "Y",
    is_width: false,
    is_wait_show: true,
    isRegUser: "N",
  }),

  watch: {
    selectList: {
      handler() {
        this.heightApplyResult();
        this.watchSubjectList();
      },

      deep: true,
    },
  },

  mounted() {
    this.pointColor = sessionStorage.getItem("pointColor");
    this.isRegUser = sessionStorage.getItem("isRegUser");

    if (
      sessionStorage.getItem("pageIdx") == 868 ||
      sessionStorage.getItem("pageIdx") == 871 ||
      sessionStorage.getItem("pageIdx") == 711 ||
      sessionStorage.getItem("pageIdx") == 712
    ) {
      this.is_wait_show = false;
    } else {
      this.is_wait_show = true;
    }
    this.is_num = localStorage.getItem("is_num");

    sessionStorage.removeItem("waitingPay");
    let viewData = sessionStorage.getItem("iiacoff_view");

    if (viewData == "Y") {
      this.is_view = viewData;
    }

    this.pointColor = sessionStorage.getItem("pointColor");
    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
    if (
      pOrder.includes("payment") &&
      sessionStorage.getItem("partial_pay") === "P"
    ) {
      this.partial_pay = sessionStorage.getItem("partial_pay");
    }
    if (pOrder.includes("payment")) {
      this.is_pay = "Y";
    } else {
      this.is_pay = "N";
    }

    if (sessionStorage.getItem("logo")) {
      if (sessionStorage.getItem("logo") === "undefined") {
        this.logo = "";
      } else {
        this.logo = sessionStorage.getItem("logo");
      }
    } else {
      this.logo = "";
    }

    if (sessionStorage.getItem("mainTitle")) {
      this.mainTitle = sessionStorage.getItem("mainTitle");
    } else {
      this.mainTitle = "";
    }

    let programIdx = sessionStorage.getItem("programIdx");
    if (!programIdx) {
      alert("프로그램 정보가 없습니다. 다시 시도해주세요.");
      this.$router.push("/user/reg/init");
      return;
    }
    let params = {
      programIdx: programIdx,
    };
    this.axios
      .get(this.axios.root + this.axios.port + `/program/${programIdx}`, {
        params: params,
      })
      .then((res) => {
        if (res.data.err === 0) {
          this.main = res.data.main;
          this.program = res.data.program;
          this.columnOrders = res.data.columnOrders;

          //classList -> classTotalList: 학습자단 검색 전용
          this.classList = res.data.classTotalList;
          this.subjectAllList = res.data.subjectList;
          this.studentSubjectList = res.data.studentSubjectList;
          this.isSearch = res.data.program.is_search;
          this.previewTime = res.data.previewTime;
          this.previewTimeList = res.data.previewTimeList;
          //previewWeek  -> previewDayList: 학습자단 검색 전용
          this.previewWeek = res.data.previewDayList;
          this.previewTutor = res.data.previewTutor;
          this.previewLevel = res.data.previewLevel;
          this.totalStudent = res.data.totalStudent;
          this.totalWaitStudentCnt = res.data.totalWaitStudentCnt;

          // 등록된 클래스가 존재할 때 처음 클래스를 기본 클래스로 지정
          if (this.classList.length > 0) {
            this.classIdx = this.classList[0].idx;
          }

          if (
            this.program.subject_dup_type === "O" &&
            this.studentSubjectList.length > 0
          ) {
            this.classIdx = this.studentSubjectList[0].idxItmSugangClass;
            for (var [cIdx, classItem] of this.classList.entries()) {
              if (classItem.idx === this.classIdx) {
                this.classNum = cIdx;
                break;
              }
            }
          }

          for (let i = 0; i < this.classList.length; i++) {
            if (this.classList[i].class_name.length >= 14) {
              this.is_width = true;
              break;
            } else {
              this.is_width = false;
            }
          }

          // backend Response가 카멜, 스네이크 명명법이 섞여있어서 키값 파싱

          for (var item of this.subjectAllList) {
            var tempObj = {};

            for (var key in item) {
              // 언어 체크박스용 어레이 생성
              if (this.snakeToCamelCase(key) === "language") {
                // this.language.push({
                //     key: item[key],
                //     value: false
                // })
              }
              if (this.snakeToCamelCase(key) == "waitingNum") {
                this.applyWaitCountNum += item[key];
              }
              if (this.snakeToCamelCase(key) == "faNum") {
                if (item[key] === 0) {
                  this.applyWaitCountNum = 9999;
                } else {
                  this.applyWaitCountNum += item[key];
                }
                console.log(this.applyWaitCountNum);
              }

              if (
                this.snakeToCamelCase(key) == "applicantNum" ||
                this.snakeToCamelCase(key) == "statusYCnt"
              ) {
                this.applyWaitCountNum -= item[key];
              }

              if (this.snakeToCamelCase(key) === "place") {
                // this.place.push({
                //     key: item[key],
                //     value: false
                // })
              }

              tempObj[this.snakeToCamelCase(key)] = item[key];
            }
            this.subjectList.push(tempObj);
          }

          if (this.applyWaitCountNum < 1) {
            alert("신청인원이 가득 차 신청가능한 수업이 없습니다.");
            this.$router.push("/lnk/" + this.main.company_code);
          }

          var sugangList = [];
          var initClassIdx = this.classList[this.classNum].idx;
          for (var item of this.subjectList) {
            if (item.idxItmSugangClass === initClassIdx) {
              sugangList.push(item);
            }
            if (initClassIdx == -999) {
              sugangList.push(item);
            }
          }

          for (var [index, item] of this.classList.entries()) {
            this.selectList.push([]);
            for (var subject of this.subjectAllList) {
              if (item.idx === subject.idxItmSugangClass) {
                this.selectList[0].push(false); //전체 데이터 삽입
                this.selectList[index].push(false);
              }
            }
          }

          let selectSubjectIdx = [];
          // console.log("suganglist")
          for (var [index, subItem] of sugangList.entries()) {
            //console.log(subItem);
            for (var item of this.studentSubjectList) {
              if (subItem.subjectIdx.toString() === item.idxItmSugangSubject) {
                if (
                  this.program.subject_dup_type === "X" ||
                  this.program.subject_dup_type === "N"
                ) {
                  // console.log(subItem);
                  // selectSubjectIdx = subItem['subjectIdx']
                  selectSubjectIdx.push(subItem["idxItmSugangClass"]);
                } else if (this.program.subject_dup_type === "O") {
                  subItem["notValid"] = true;
                }
                // A 타입은 notValid 설정하지 않음 (중복 가능)
              }
            }
          }
          // console.log(selectSubjectIdx);
          if (
            this.program.subject_dup_type === "X" ||
            this.program.subject_dup_type === "N"
          ) {
            // console.log(selectSubjectIdx);
            for (var [index, subItem] of sugangList.entries()) {
              // if(subItem['subjectIdx'] == selectSubjectIdx){
              // }
              // console.log(subItem['subjectIdx'])
              for (let i = 0; i < selectSubjectIdx.length; i++) {
                if (subItem["idxItmSugangClass"] == selectSubjectIdx[i]) {
                  subItem["notValid"] = true;
                }
              }
            }
          }

          for (let item of sugangList) {
            // 클래스 전체 선착순일때 세팅
            if (item.faType === "AF") {
              this.faMain.value = true;
              this.faMain.faNum = item.faNum;
              this.faMain.faType = item.faType;
              this.faMain.restYn = item.restYn;
              this.faMain.waitingNum = item.waitingNum;
              this.faMain.applicantNum = item.applicantNum;
              this.faMain.statusYCnt = item.statusYCnt;
              this.waitCountNum += item.statusYCnt;
              this.applyCountNum += item.applicantNum;

              // console.log('this.applyCountNum', this.applyCountNum)
            }

            // console.log('!!!!!item', item)
            for (let key in item) {
              // 언어 체크박스용 어레이 생성
              let count = 0;
              if (key === "language") {
                for (var lang of this.language) {
                  if (lang.key === item[key]) {
                    count += 1;
                  }
                }
                if (count > 0) {
                  continue;
                } else {
                  if (this.language.length < 20) {
                    this.language.push({
                      key: item[key],
                      value: false,
                    });
                  }
                }
              }

              // 장소 체크박스용 어레이 생성
              if (key === "place") {
                for (var pl of this.place) {
                  if (pl.key === item[key]) {
                    count += 1;
                  }
                }
                if (count > 0) {
                  continue;
                } else {
                  if (this.place.length < 20) {
                    this.place.push({
                      key: item[key],
                      value: false,
                    });
                  }
                }
              }

              // 요일 체크박스용 어레이 생성
              if (key === "day") {
                let dyArr = item[key].split("^");
                for (var dyVal of dyArr) {
                  for (var dy of this.weekday) {
                    if (dy.key === dyVal) {
                      count += 1;
                    }
                  }
                  if (count > 0) {
                    continue;
                  } else {
                    if (this.weekday.length < 20) {
                      this.weekday.push({
                        key: dyVal,
                        value: false,
                      });
                    }
                  }
                }
              }

              //시간
              if (key === "subjectTime") {
                const found = this.time.find((item) => item.key === item[key]);
                // console.log(this.time);
                if (found === undefined) {
                  this.time.push({
                    key: item[key],
                    value: false,
                  });
                }
              }

              if (key === "teacher") {
                for (var tc of this.teacher) {
                  if (tc.key === item[key]) {
                    count += 1;
                  }
                }
                if (count > 0) {
                  continue;
                } else {
                  if (this.teacher.length < 20 && item[key]) {
                    this.teacher.push({
                      key: item[key],
                      value: false,
                    });
                  }
                }
              }

              if (key === "level") {
                for (var lv of this.level) {
                  if (lv.key === item[key]) {
                    count += 1;
                  }
                }
                if (count > 0) {
                  continue;
                } else {
                  if (this.level.length < 20) {
                    this.level.push({
                      key: item[key],
                      value: false,
                    });
                  }
                }
              }
            }
          }

          // this.isBlocked = false
          // if (this.faMain.)

          // console.log('sugangList13312', sugangList)

          this.sugangList = JSON.parse(JSON.stringify(sugangList));

          //시간 중복 제거
          const copytime = [];
          for (let item of this.time) {
            const found = copytime.find(
              (copyitem) => copyitem.key === item.key,
            );
            if (!found) {
              copytime.push(item);
            }
          }
          this.time = copytime;
        } else {
          alert(res.data.result);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    var pathArray = this.$route.fullPath.split("/");
    var length = pathArray.length;
    var pageType = pathArray[length - 1];
    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
    var finishPage = pOrder[pOrder.length - 1];

    if (finishPage === "complete") {
      if (pageType === pOrder[pOrder.length - 2]) {
        this.isRegPage = true;
      }
    }

    if (pageType === finishPage) {
      this.isFinishPage = true;
    }
  },

  methods: {
    watchSubjectList() {
      /**
       * @description : 중복 가능 타입(subject_dup_type)
       * 총 4가지 중복가능(A) , 과정 내 중복 가능 / 타 과정 중복 불가능(O),  중복 불가(X) ,과목 내 불가/타 과목 중복 가능(N)
       */

      /// [중복 가능] => A or [과목 내 중복 가능 / 타 과목 중복 불가능] => O
      if (
        this.program.subject_dup_type === "O" ||
        this.program.subject_dup_type === "A"
      ) {
        for (let [index, item] of this.selectList[this.classNum].entries()) {
          let sugangList = JSON.parse(JSON.stringify(this.sugangList));
          if (item) {
            var checkCount = 0;

            for (let [idx, payment] of this.paymentList.entries()) {
              if (payment.subjectIdx === sugangList[index].subjectIdx) {
                checkCount += 1;
                continue;
              }
              //요일 체크용
              let checkDayCnt = 0;

              let paymentDayArr = payment.day.split("^");
              let itemDayArr = sugangList[index].day.split("^");
              for (var pday of paymentDayArr) {
                for (var iday of itemDayArr) {
                  if (
                    pday == iday &&
                    pday !== "" &&
                    pday !== "undefined" &&
                    pday !== "null"
                  )
                    checkDayCnt += 1;
                }
              }
              //같은요일에 겹치는 시간대가 있는지 체크
              if (
                checkDayCnt >= 1 &&
                ((payment.subjectStartTime <=
                  sugangList[index].subjectStartTime &&
                  sugangList[index].subjectStartTime <=
                    payment.subjectEndTime) ||
                  (payment.subjectStartTime <=
                    sugangList[index].subjectEndTime &&
                    sugangList[index].subjectEndTime <= payment.subjectEndTime))
              ) {
                checkCount += 1;
              }
            }

            if (checkCount === 0) {
              sugangList[index]["selectIdx"] = index;
              this.paymentList.push(sugangList[index]);
              this.totalPayment += sugangList[index].eduPrice;
              this.totalPayment += sugangList[index].bookPrice;
              if (sugangList[index].checked == true) {
                sugangList[index].checked = false;
              } else {
                sugangList[index].checked = true;
              }
            }
          } else {
            for (let [idx, payment] of this.paymentList.entries()) {
              if (payment.subjectIdx === sugangList[index].subjectIdx) {
                this.totalPayment -= sugangList[index].eduPrice;
                this.totalPayment -= sugangList[index].bookPrice;
                this.paymentList.splice(idx, 1);
              }
            }
          }
        }

        // 과정 내 중복 가능 / 타 과정 중복 불가능
        if (this.program.subject_dup_type === "O") {
          const filter = this.sugangList.filter(
            (sugangItem) => sugangItem["checked"] === true,
          );

          if (filter.length > 0) {
            const { idxItmSugangClass } = filter[0];
            this.sugangList.forEach((sugangItem) => {
              if (sugangItem["idxItmSugangClass"] !== idxItmSugangClass) {
                sugangItem["notValid"] = true;
                r;
              }
            });
          }
        }
      }
      /// [중복 불가] => X or [과목 내 불가/타 과목 중복 가능] => N
      else if (
        this.program.subject_dup_type === "X" ||
        this.program.subject_dup_type === "N"
      ) {
        var count = 0;

        //수강리스트 조회
        for (let [index, item] of this.selectList[this.classNum].entries()) {
          var sugangList = JSON.parse(JSON.stringify(this.sugangList));
          if (item) {
            const selectItem = sugangList.find(
              (sugangItem) =>
                sugangItem.subjectIdx == sugangList[index].subjectIdx,
            );
            const findIdx = this.paymentList.findIndex((paymentItem) => {
              paymentItem.subjectIdx === selectItem.subjectIdx;
            });

            if (findIdx < 0) {
              var checkCount = 0;
              for (let [idx, payment] of this.paymentList.entries()) {
                if (payment.subjectIdx === sugangList[index].subjectIdx) {
                  checkCount += 1;
                  continue;
                }
                //요일 체크용
                let checkDayCnt = 0;

                let paymentDayArr = payment.day.split("^");
                let itemDayArr = sugangList[index].day.split("^");
                for (var pday of paymentDayArr) {
                  for (var iday of itemDayArr) {
                    if (
                      pday == iday &&
                      pday !== "" &&
                      pday !== "undefined" &&
                      pday !== "null"
                    )
                      checkDayCnt += 1;
                  }
                }
                //같은요일에 겹치는 시간대가 있는지 체크
                if (
                  checkDayCnt >= 1 &&
                  ((payment.subjectStartTime <=
                    sugangList[index].subjectStartTime &&
                    sugangList[index].subjectStartTime <=
                      payment.subjectEndTime) ||
                    (payment.subjectStartTime <=
                      sugangList[index].subjectEndTime &&
                      sugangList[index].subjectEndTime <=
                        payment.subjectEndTime))
                ) {
                  checkCount += 1;
                }
              }
              if (checkCount === 0) {
                this.paymentList.push(sugangList[index]);
                this.totalPayment += sugangList[index].eduPrice;
                this.totalPayment += sugangList[index].bookPrice;
              }
            }
          } else {
            this.paymentList.forEach((paymentItem, paymentIndex) => {
              if (sugangList[index]) {
                if (paymentItem.subjectIdx === sugangList[index].subjectIdx) {
                  this.totalPayment -= sugangList[index].eduPrice;
                  this.totalPayment -= sugangList[index].bookPrice;
                  this.paymentList.splice(paymentIndex, 1);
                }
              }
            });
          }
        }
        // console.log(this.firstWatch);
        let selectSubjectIdx = [];
        if (!this.firstWatch) {
          // console.log(count)
          if (count === 0) {
            for (let [idx, sugang] of this.sugangList.entries()) {
              var count = 0;
              for (var ssList of this.studentSubjectList) {
                // console.log("idxItmSugangSubject  : " + ssList.idxItmSugangSubject)
                // console.log("subjectIdx  : " +  sugang.subjectIdx.toString())
                if (
                  ssList.idxItmSugangSubject === sugang.subjectIdx.toString()
                ) {
                  // sugang.notValid = true
                  selectSubjectIdx.push(sugang.idxItmSugangClass);
                  count += 1;
                }
              }
              if (count === 0) {
                sugang.notValid = false;
              }
            }

            // console.log("수깅 리스트")
            for (var [index, subItem] of this.sugangList.entries()) {
              for (let i = 0; i < selectSubjectIdx.length; i++) {
                if (subItem["idxItmSugangClass"] == selectSubjectIdx[i]) {
                  // subItem['notValid'] = true;
                  // console.log(subItem);
                  subItem.notValid = true;
                }
              }
            }
          }
        } else {
          this.firstWatch = false;
        }

        const copyClassList = _.cloneDeep(
          this.classList.filter((classItem) => classItem.idx !== -999),
        );
        //중복 불가
        if (this.program.subject_dup_type === "X") {
          copyClassList.forEach((classItem) => {
            const { idx } = classItem;
            const filterLen = this.sugangList.filter(
              (sugangItem) =>
                sugangItem["checked"] === true &&
                sugangItem["idxItmSugangClass"] === idx,
            ).length;

            if (filterLen > 0) {
              this.sugangList.forEach((sugangItem) => {
                if (
                  !sugangItem["checked"] &&
                  sugangItem["idxItmSugangClass"] === idx
                ) {
                  sugangItem["notValid"] = true;
                }
              });
            } else {
              const paymentLen = this.paymentList.length;
              if (paymentLen > 0) {
                this.sugangList.forEach((sugangItem) => {
                  if (!sugangItem["checked"]) {
                    sugangItem["notValid"] = true;
                  }
                });
              }
            }
          });
        }

        //[과목 내 불가/타 과목 중복 가능]
        else if (this.program.subject_dup_type === "N") {
          copyClassList.forEach((classItem) => {
            const { idx } = classItem;
            const filterLen = this.sugangList.filter(
              (sugangItem) =>
                sugangItem["checked"] === true &&
                sugangItem["idxItmSugangClass"] === idx,
            ).length;
            if (filterLen > 0) {
              this.sugangList.forEach((sugangItem) => {
                if (
                  !sugangItem["checked"] &&
                  sugangItem["idxItmSugangClass"] === idx
                ) {
                  sugangItem["notValid"] = true;
                }
              });
            }
          });
        }
      }

      if (this.partial_pay === "P") {
        for (var [idx, payment] of this.paymentList.entries()) {
          if (
            Object.keys(payment).includes("useEdu") ||
            Object.keys(payment).includes("useBook")
          ) {
            continue;
          } else {
            payment.useEdu = true;
            payment.useBook = true;
          }
        }
      }
    },

    moveMobileApplyList() {
      this.closeMenu();
      this.$router.push("/user/applyList");
    },

    logoutMobile() {
      this.axios
        .get(this.axios.root + this.axios.port + "/login/out")
        .then((res) => {
          if (res.data.err === 0) {
            this.closeMenu();
            localStorage.removeItem("userId");
            localStorage.removeItem("accessToken");
            delete this.axios.defaults.headers.common["accessToken"];
            var tempCompanyCode = sessionStorage.getItem("companyCode");
            sessionStorage.clear();
            sessionStorage.setItem("companyCode", tempCompanyCode);
            alert("로그아웃 되었습니다.");
            this.$router.push("/user/login");
          }
        });
    },

    openMenu() {
      // console.log(document.getElementById('select-header-menu').class)
      document.getElementById("select-header-menu").style =
        "display:inherit !important;";
    },

    openMenuSub() {
      // console.log(document.getElementById('select-header-menu-sub').class)
      document.getElementById("select-header-menu-sub").style =
        "display:inherit !important;";
    },

    closeMenu() {
      document.getElementById("select-header-menu").style =
        "display:none !important;";
    },

    closeMenuSub() {
      document.getElementById("select-header-menu-sub").style =
        "display:none !important;";
    },

    // height 유동적으로 변경
    heightApplyResult() {
      if (document.getElementById("select-apply-result")) {
        return document.getElementById("select-apply-result").offsetHeight;
      } else {
        return 0;
      }
    },
    checkedItem(item) {
      //체크박스 CSS용
      if (item.checked == true) {
        item.checked = false;
        this.checkBoxCheckNum--;
      } else {
        //확인용
        let checkCount = 0;
        for (var payment of this.paymentList) {
          //요일 체크용
          let checkDayCnt = 0;
          let paymentDayArr = payment.day.split("^");
          let itemDayArr = item.day.split("^");
          for (var pday of paymentDayArr) {
            for (var iday of itemDayArr) {
              if (
                pday == iday &&
                pday !== "" &&
                pday !== "undefined" &&
                pday !== "null"
              )
                checkDayCnt += 1;
            }
          }
          //같은요일에 겹치는 시간대가 있는지 체크
          if (
            checkDayCnt >= 1 &&
            ((payment.subjectStartTime <= item.subjectStartTime &&
              item.subjectStartTime <= payment.subjectEndTime) ||
              (payment.subjectStartTime <= item.subjectEndTime &&
                item.subjectEndTime <= payment.subjectEndTime))
          ) {
            checkCount += 1;
            alert(
              payment.subjectName +
                "(" +
                payment.day.replace(/\^/gi, "") +
                " " +
                payment.subjectStartTime +
                "~" +
                payment.subjectEndTime +
                ")" +
                " 클래스와 시간대가 중복됩니다.",
            );
            break;
          }
        }
        if (checkCount == 0) {
          item.checked = true;
          this.checkBoxCheckNum++;
        }
        if (
          this.program.subject_dup_type_n_limit != 0 &&
          this.program.subject_dup_type_n_limit <
            this.checkBoxCheckNum +
              this.studentSubjectList.filter((item) => item.delStatus === "N")
                .length
        ) {
          alert(
            "최대 신청 가능 강의수는 " +
              this.program.subject_dup_type_n_limit +
              " 개 입니다\n현재 신청 되어있는 강의수 : " +
              this.studentSubjectList.filter((item) => item.delStatus === "N")
                .length,
          );
        }
      }
      console.log(`checkBoxNum : ${this.checkBoxCheckNum}`);
    },

    // 클래스 블럭 처리 여부
    checkBlock(item) {
      if (item.faType === "N") {
        return false;
      } else if (item.faType === "SF") {
        const condition =
          item.applicantNum + item.statusYCnt >= item.faNum + item.waitingNum;
        if (condition) {
          return true;
        } else {
          return false;
        }
      } else if (item.faType === "AF") {
        const condition =
          this.applyCountNum + this.waitCountNum >=
          item.faNum + item.waitingNum;
        if (condition) {
          return true;
        } else {
          return false;
        }
      }
    },

    // notValid 또는 checkBlock 조건 확인 (디버깅용)
    isItemBlocked(item) {
      const notValidResult = item.notValid === true;
      const checkBlockResult = this.checkBlock(item);
      const finalResult = notValidResult || checkBlockResult;

      return finalResult;
    },

    // 컬럼값이 비었는지 확인
    isEmptyItem(data) {
      var count = 0;
      for (var item of data) {
        if (item.key === "") {
          continue;
        } else {
          count += 1;
        }
      }

      if (count > 0) {
        return true;
      } else {
        return false;
      }
    },

    // 탭 색깔 반영
    setTabColor(idx) {
      if (this.classIdx === idx) {
        if (this.pointColor === "Blue") {
          return "blue";
        } else if (this.pointColor === "Red") {
          return "red";
        } else if (this.pointColor === "Green") {
          return "green";
        }
      }
    },

    // 수강신청 제작에서 세팅한 컬러로 반영
    setColor() {
      if (this.pointColor === "Blue") {
        return "on-blue";
      } else if (this.pointColor === "Red") {
        return "on-red";
      } else if (this.pointColor === "Green") {
        return "on-green";
      }
    },
    // 수강신청 제작에서 세팅한 컬러로 반영 checkon-blue
    setColorByItem(item) {
      if (item === true) {
        if (this.pointColor === "Blue") {
          return "on-blue";
        } else if (this.pointColor === "Red") {
          return "on-red";
        } else if (this.pointColor === "Green") {
          return "on-green";
        }
      } else {
        return "on-default";
      }
    },

    // 프로그램 등록에서 선택한 컬럼만 출력되게
    viewItemList(data) {
      if (data.columnOrder) {
        var itemList = data.columnOrder.split("^");
        var returnItemList = [];
        for (var item of itemList) {
          if (item === "언어") {
            returnItemList.push({
              key: item,
              value: data.language,
            });
          } else if (item === "장소") {
            returnItemList.push({
              key: item,
              value: data.place,
            });
          } else if (item === "요일") {
            if (data.day && typeof data.day === "string") {
              returnItemList.push({
                key: item,
                // ie11에서 replaceAll 지원안해서 해당 코드로 진행
                value: data.day.replace(/\^/gi, ""),
              });
            }
          } else if (item === "교육시간") {
            returnItemList.push({
              key: item,
              value: data.subjectStartTime + "~" + data.subjectEndTime,
            });
          } else if (item === "교육비") {
            returnItemList.push({
              key: item,
              value: data.eduPrice
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            });
          } else if (item === "교재비") {
            returnItemList.push({
              key: item,
              value: data.bookPrice
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            });
          } else if (item === "레벨") {
            returnItemList.push({
              key: item,
              value: data.level,
            });
          } else if (item === "강사") {
            returnItemList.push({
              key: item,
              value: data.teacher,
            });
          }
        }
        return returnItemList;
      } else {
        return [];
      }
      // console.log('data', data)
      return [""];
    },

    calcEduPrice(type, index, flag) {
      if (!flag) {
        this.paymentList[index][type + "bu"] = this.paymentList[index][type];
        this.totalPayment -= this.paymentList[index][type];
        this.paymentList[index][type] = 0;
      } else {
        this.paymentList[index][type] = this.paymentList[index][type + "bu"];
        this.totalPayment += this.paymentList[index][type];
      }
    },

    cancelSugang(data) {
      for (var [index, item] of this.paymentList.entries()) {
        if (item.subjectIdx === data.subjectIdx) {
          for (var [checkIdx, partClass] of this.classList.entries()) {
            if (partClass.idx === data.idxItmSugangClass) {
              this.selectList[checkIdx][item.selectIdx] = false;
              break;
            }
          }
          this.totalPayment -= item.eduPrice;
          this.totalPayment -= item.bookPrice;
          this.paymentList.splice(index, 1);
          // break
        }
      }
    },

    // 전체클래스 상세보기 윈도우 팝업 열기
    // 파일 위치는 components/reg/detail.vue
    openDefaultPopup() {
      if (sessionStorage.getItem("selectPopup")) {
        let routeData = this.$router.resolve({
          name: "reg-select-popup",
          query: {
            mainIdx: sessionStorage.getItem("mainIdx"),
          },
        });
        window.open(
          routeData.href,
          "window팝업",
          "width=500, height=400, top:50, left:50, menubar=no, status=no, toolbar=no",
        );
      }
    },

    selectOption(event) {
      this.selectClass(event.target.value, 0);
    },
    // 왼쪽 탭의 클래스 선택시 (idx는 과목의 인덱스, index는 왼쪽 탭의 순서번호)

    selectClass(idx, index) {
      if (
        this.program.subject_dup_type === "O" &&
        this.studentSubjectList.length > 0
      ) {
        alert("이미 신청한 과정이 있습니다.");
        return false;
      }

      // AF타입인 경우에 신청자 내역 초기화
      this.applyCountNum = 0;
      this.waitCountNum = 0;
      this.end = "Y";
      this.changeClass = true;
      // console.log('selectClass', idx, index)
      if (this.classIdx !== idx) {
        this.classIdx = idx;
        //this.classNum = index;
        this.resetSearch();
        this.changeSearchItem();
        this.validCheck();

        //장소 검색조건(searchObject) 필터
        if (this.place[0].key) {
          for (let i = 0; i < this.searchObject.place.length; i++) {
            const findIdx = this.place.findIndex(
              (item) => this.searchObject[i] === item.key,
            );
            if (!findIdx) {
              this.searchObject.place.splice(index, 1);
            }
          }
        } else {
          this.searchObject.place = [];
        }

        //시간 검색조건(searchObject) 필터
        const copytime = [];
        for (let item of this.time) {
          const found = copytime.find((copyitem) => copyitem.key === item.key);
          if (!found) {
            copytime.push(item);
          }
        }
        this.time = copytime;
        for (let i = 0; i < this.searchObject.time.length; i++) {
          const findIdx = this.time.findIndex(
            (item) => this.searchObject[i] === item.key,
          );
          if (!findIdx) {
            this.searchObject.time.splice(index, 1);
          }
        }

        //강사 검색조건(searchObject) 필터
        if (this.teacher[0].key) {
          for (let i = 0; i < this.searchObject.teacher.length; i++) {
            const findIdx = this.teacher.findIndex(
              (item) => this.searchObject[i] === item.key,
            );
            if (!findIdx) {
              this.searchObject.teacher.splice(index, 1);
            }
          }
        } else {
          this.searchObject.teacher = [];
        }

        //레벨 검색조건(searchObject) 필터
        if (this.level[0].key) {
          for (let i = 0; i < this.searchObject.level.length; i++) {
            const findIdx = this.level.findIndex(
              (item) => this.searchObject[i] === item.key,
            );
            if (!findIdx) {
              this.searchObject.level.splice(index, 1);
            }
          }
        } else {
          this.searchObject.level = [];
        }

        this.searchClass();
      }

      /*
            클래스 변경시 오류 유발로 주석처리
            this.watchSubjectList()
            */
    },

    validCheck() {
      /// subject_dup_type의 상태
      /// 모두 중복 가능 A, 과목 내 중복 가능 / 타 과목 중복 불가능 O, 과목 내 불가/타 과목 중복 가능 N, 중복 불가 X

      /// [과목 내 중복 가능 / 타 과목 중복 불가능] 및 [모두 중복 가능] 을 제외
      if (
        this.program.subject_dup_type !== "O" &&
        this.program.subject_dup_type !== "A"
      ) {
        for (var [index, item] of this.selectList[this.classNum].entries()) {
          if (item) {
            for (var [idx, sugang] of this.sugangList.entries()) {
              if (index !== idx) {
                sugang.notValid = true;
              }
            }
          }
        }
      }

      /// [중복 불가] 혹은 [과목 내 중복 가능 / 타 과목 중복 불가능] 인경우
      /*
            클래스 변경시 오류 유발로 주석처리
            if (this.program.subject_dup_type === 'X' || this.program.subject_dup_type === 'O') {

                this.totalPayment = 0
            }
            */
    },

    // 왼쪽 탭의 클릭한 수업으로 리스트 변경
    changeSearchItem() {
      let sugangList = [];
      for (let item of this.subjectAllList) {
        if (item.idxItmSugangClass === this.searchOption) {
          sugangList.push(item);
        }
        if (this.searchOption == -999) {
          sugangList.push(item);
        }
      }

      // 수업 리스트, 언어-지역 검색쿼리 빈 값으로 초기화
      this.subjectList = [];
      this.language = [];
      this.place = [];
      this.level = [];
      this.time = [];
      this.teacher = [];
      this.weekday = [];

      // 카멜, 스네이크값 일관되게 키값 파싱

      for (var item of sugangList) {
        var tempObj = {};

        if (item.faType === "AF") {
          this.faMain.value = true;
          this.faMain.faNum = item.faNum;
          this.faMain.faType = item.faType;
          this.faMain.restYn = item.restYn;
          this.faMain.waitingNum = item.waitingNum;
          this.faMain.applicantNum = item.applicantNum;
          this.faMain.statusYCnt = item.statusYCnt;
          //
          this.applyCountNum += item.applicantNum;
          this.waitCountNum += item.statusYCnt;
        } else {
          this.faMain = {
            value: false,
            faNum: 0,
            faType: "N",
            watingNum: "", // 대기자 계산
            restYn: "", // 잔여인원 표시여부
            applicantNum: "", // 신청자수
          };
        }

        for (var key in item) {
          // 언어 체크박스용 어레이 생성
          var count = 0;
          if (this.snakeToCamelCase(key) === "language") {
            if (key === "language") {
              for (var lang of this.language) {
                if (lang.key === item[key]) {
                  count += 1;
                }
              }
              if (count > 0) {
                continue;
              } else {
                if (this.language.length < 20) {
                  this.language.push({
                    key: item[key],
                    value: false,
                  });
                }
              }
            }
          }

          // 지역 체크박스용 어레이 생성
          if (this.snakeToCamelCase(key) === "place") {
            if (key === "place") {
              for (var pl of this.place) {
                if (pl.key === item[key]) {
                  count += 1;
                }
              }
              if (count > 0) {
                continue;
              } else {
                if (this.place.length < 20) {
                  this.place.push({
                    key: item[key],
                    value: false,
                  });
                }
              }
            }
          }

          // 요일 체크박스용 어레이 생성
          if (this.snakeToCamelCase(key) === "day") {
            if (key === "day") {
              let dyArr = item[key].split("^");
              for (var dyVal of dyArr) {
                for (var dy of this.weekday) {
                  if (dy.key === dyVal) {
                    count += 1;
                  }
                }
                if (count > 0) {
                  continue;
                } else {
                  if (this.weekday.length < 20) {
                    this.weekday.push({
                      key: dyVal,
                      value: false,
                    });
                  }
                }
              }
            }
          }

          // 시간 체크박스용 어레이 생성
          if (this.snakeToCamelCase(key) === "subjectTime") {
            if (key === "subjectTime") {
              const found = this.time.find((item) => item.key === item[key]);

              if (!found) {
                this.time.push({
                  key: item[key],
                  value: false,
                });
              }
            }
          }

          // 강사 체크박스용 어레이 생성
          if (this.snakeToCamelCase(key) === "teacher") {
            if (key === "teacher") {
              for (var tc of this.teacher) {
                if (tc.key === item[key]) {
                  count += 1;
                }
              }
              if (count > 0) {
                continue;
              } else {
                if (this.teacher.length < 20) {
                  this.teacher.push({
                    key: item[key],
                    value: false,
                  });
                }
              }
            }
          }

          // 레벨 체크박스용 어레이 생성
          if (this.snakeToCamelCase(key) === "level") {
            if (key === "level") {
              for (var lv of this.level) {
                if (lv.key === item[key]) {
                  count += 1;
                }
              }
              if (count > 0) {
                continue;
              } else {
                if (this.level.length < 20) {
                  this.level.push({
                    key: item[key],
                    value: false,
                  });
                }
              }
            }
          }

          tempObj[this.snakeToCamelCase(key)] = item[key];
        }

        if (item.select) {
          tempObj["select"] = true;
        }
        this.subjectList.push(tempObj);
      }

      // 중복신청 불가능일때 막기 (A 타입은 예외)
      if (this.program.subject_dup_type !== "A") {
        for (var item of this.studentSubjectList) {
          for (var subItem of sugangList) {
            if (subItem.subjectIdx.toString() === item.idxItmSugangSubject) {
              subItem["notValid"] = true;
            }
          }
        }
      }

      // console.log('sugangList', sugangList)

      this.sugangList = JSON.parse(JSON.stringify(sugangList));
    },

    // 검색 쿼리 초기화
    resetSearch() {
      var tempArray = ["language", "place", "subjectTime", "day"];
      for (var variable of tempArray) {
        for (var item of this[variable]) {
          item.value = false;
        }
      }
    },

    // 스네이크케이스 => 카멜케이스 변환
    snakeToCamelCase(key) {
      var camelCased = key.replace(/_([a-z])/g, function (g) {
        return g[1].toUpperCase();
      });
      return camelCased;
    },

    tabClick() {
      let subjectTimeChk = document.querySelectorAll("input[name=subjectTime]");
      for (let i = 0; i < subjectTimeChk.length; i++) {
        subjectTimeChk[i].checked = false;
      }

      let dayChk = document.querySelectorAll("input[name=day]");
      for (let i = 0; i < dayChk.length; i++) {
        dayChk[i].checked = false;
      }

      let teacherChk = document.querySelectorAll("input[name=teacher]");
      for (let i = 0; i < teacherChk.length; i++) {
        teacherChk[i].checked = false;
      }

      let levelChk = document.querySelectorAll("input[name=level]");
      for (let i = 0; i < levelChk.length; i++) {
        levelChk[i].checked = false;
      }
    },

    getClass(params) {
      //all false 처리
      for (
        let selectIndex = 0;
        selectIndex < this.selectList.length;
        selectIndex++
      ) {
        for (
          let subIndex = 0;
          subIndex < this.selectList[selectIndex].length;
          subIndex++
        ) {
          this.selectList[selectIndex][subIndex] = false;
        }
      }

      const findIdx = this.classList.findIndex(
        (classItem) => classItem.idx === this.searchOption,
      );

      this.classNum = findIdx;
      this.axios
        .get(
          this.axios.root +
            this.axios.port +
            `/program/search-subject/${this.classIdx}`,
          {
            params: params,
          },
        )
        .then((res) => {
          if (res.data.err === 0) {
            this.sugangList = [];
            const copySugangList = _.cloneDeep(res.data.sugangList);
            const copyClassList = _.cloneDeep(
              this.classList.filter((classItem) => classItem.idx !== -999),
            );

            copySugangList.forEach((copyItem, index) => {
              copyItem["selected"] = false;
              for (var plist of this.paymentList) {
                if (
                  copyItem.subjectIdx === plist.subjectIdx &&
                  copyItem.idxItmSugangClass === plist.idxItmSugangClass
                ) {
                  this.selectList[this.classNum][index] = true;
                  copyItem["checked"] = true;
                } else {
                  if (this.program.subject_dup_type === "X") {
                    // 중복신청 불가인 경우 탭 선택시 notValid값 연동
                    copyItem["notValid"] = true;
                  }
                }
              }

              this.sugangList.push(copyItem);
            });

            // 중복 불가 인 경우
            if (this.program.subject_dup_type === "X") {
              //수업리스트 조회
              const copyClassList = _.cloneDeep(
                this.classList.filter((classItem) => classItem.idx !== -999),
              );

              copyClassList.forEach((classItem) => {
                const { idx } = classItem;
                const filterLen = this.sugangList.filter(
                  (sugangItem) =>
                    sugangItem["checked"] === true &&
                    sugangItem["idxItmSugangClass"] === idx,
                ).length;
                console.log("filterLen : ", filterLen);
                if (filterLen > 0) {
                  this.sugangList.forEach((sugangItem) => {
                    if (
                      !sugangItem["checked"] &&
                      sugangItem["idxItmSugangClass"] === idx
                    ) {
                      sugangItem["notValid"] = true;
                    }
                  });
                } else {
                  const paymentLen = this.paymentList.length;
                  if (paymentLen > 0) {
                    this.sugangList.forEach((sugangItem) => {
                      if (!sugangItem["checked"]) {
                        sugangItem["notValid"] = true;
                      }
                    });
                  }
                }
              });
            }

            // 과정 내 중복 가능 / 타 과정 중복 불가능
            if (this.program.subject_dup_type === "O") {
              if (this.paymentList.length > 0) {
                const { idxItmSugangClass } = this.paymentList[0];

                this.sugangList.forEach((sugangItem) => {
                  if (sugangItem["idxItmSugangClass"] !== idxItmSugangClass) {
                    sugangItem["notValid"] = true;
                  }
                });
              }
            }

            // 과정 내 불가/타 과정 중복 가능
            if (this.program.subject_dup_type === "N") {
              copyClassList.forEach((classItem) => {
                const { idx } = classItem;
                const filterLen = this.sugangList.filter(
                  (sugangItem) =>
                    sugangItem["checked"] === true &&
                    sugangItem["idxItmSugangClass"] === idx,
                ).length;
                if (filterLen > 0) {
                  this.sugangList.forEach((sugangItem) => {
                    if (
                      !sugangItem["checked"] &&
                      sugangItem["idxItmSugangClass"] === idx
                    ) {
                      sugangItem["notValid"] = true;
                    }
                  });
                }
              });
            }

            var sugangList = JSON.parse(JSON.stringify(this.sugangList));

            if (this.faMain.faType === "AF" && this.isBeforeListZero) {
              this.faMain = Object.assign({}, this.backUpFaMain);
              this.isBeforeListZero = false;
            }

            //수업정보 세팅
            if (sugangList.length > 0) {
              const fistItem = Object.assign({}, sugangList[0]);
              if (fistItem.faType === "AF") {
                this.faMain.value = true;
                this.faMain.faNum = item.faNum;
                this.faMain.faType = item.faType;
                this.faMain.restYn = item.restYn;
                this.faMain.waitingNum = item.waitingNum;
                this.faMain.applicantNum = item.applicantNum;
              }
            }

            for (var item of sugangList) {
              if (item.faType !== "AF") {
                this.faMain = {
                  value: false,
                  faNum: 0,
                  faType: "N",
                  watingNum: "", // 대기자 계산
                  restYn: "", // 잔여인원 표시여부
                  applicantNum: "", // 신청자수
                };
              }
            }

            for (var [index, subItem] of sugangList.entries()) {
              for (var item of this.studentSubjectList) {
                if (
                  subItem.subjectIdx.toString() === item.idxItmSugangSubject
                ) {
                  subItem["notValid"] = true;
                }
              }
            }

            this.sugangList = JSON.parse(JSON.stringify(sugangList));

            //장바구니 중복 입력 유발로 주석처리 this.watchSubjectList()
          } else {
            this.sugangList = [];
            if (this.faMain.faType === "AF") {
              this.isBeforeListZero = true;
              this.backUpFaMain = JSON.parse(JSON.stringify(this.faMain));
              this.faMain = {
                value: false,
                faNum: 0,
                faType: "N",
                watingNum: "", // 대기자 계산
                restYn: "", // 잔여인원 표시여부
                applicantNum: "", // 신청자수
              };
            }

            alert("검색 결과가 없습니다.");
            return false;
          }
        });
    },

    // 강의검색
    searchClass() {
      /**
       * 요일 및 시간 체크박스 이벤트 처리
       */
      let subjectTime = document.querySelectorAll(
        "input[name=subjectTime]:checked",
      );
      let subjectStartTime = document.querySelectorAll(
        "input[name=subjectStartTime]:checked",
      );

      let day = document.querySelectorAll("input[name=day]:checked");
      let teacher = document.querySelectorAll("input[name=teacher]:checked");
      let level = document.querySelectorAll("input[name=level]:checked");
      let language = document.querySelectorAll("input[name=language]:checked");
      let place = document.querySelectorAll("input[name=place]:checked");

      let subjectTimeArr = [];
      let subjectStartTimeArr = [];
      let dayArr = [];
      let teacherArr = [];
      let levelArr = [];
      let languageArr = [];

      for (let i = 0; i < subjectTime.length; i++) {
        subjectTimeArr.push(subjectTime[i].value);
      }

      for (let i = 0; i < subjectStartTime.length; i++) {
        subjectStartTimeArr.push(subjectStartTime[i].value);
      }
      for (let j = 0; j < day.length; j++) {
        dayArr.push(day[j].value);
      }
      for (let j = 0; j < teacher.length; j++) {
        teacherArr.push(teacher[j].value);
      }
      for (let j = 0; j < level.length; j++) {
        levelArr.push(level[j].value);
      }
      for (let j = 0; j < language.length; j++) {
        languageArr.push(language[j].value);
      }

      const params = {
        classIdx: this.classIdx,
        programIdx: this.programIdx,
        language: languageArr.join("|"),
        place: this.searchObject.place.join("|"),
        subjectTime: subjectStartTimeArr.join("|"),
        day: dayArr.join("|"),
        teacher: teacherArr.join("|"),
        level: levelArr.join("|"),
        end: this.end,
      };

      this.getClass(params);
    },

    // 체크박스 형태 오브젝트 => 영어/중국어/일본어 String 형태로 변경
    convertQuery(array) {
      var tempArray = [];

      for (var item of array) {
        if (item.value) {
          tempArray.push(item.key);
        }
      }
      tempArray = tempArray.join("/");

      return tempArray;
    },

    // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
    numberFormat(inputNumber) {
      return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    // 수강신청 진행
    apply() {
      let programIdx = sessionStorage.getItem("programIdx");
      let params = {
        programIdx: programIdx,
      };
      this.axios
        .get(this.axios.root + this.axios.port + `/program/${programIdx}`, {
          params: params,
        })
        .then((res) => {
          if (res.data.err === 0) {
            this.main = res.data.main;
            this.program = res.data.program;

            //classList -> classTotalList: 학습자단 검색 전용
            this.classList = res.data.classTotalList;
            this.subjectAllList = res.data.subjectList;
            this.studentSubjectList = res.data.studentSubjectList;
            this.isSearch = res.data.program.is_search;
            this.previewTime = res.data.previewTime;
            this.previewTimeList = res.data.previewTimeList;
            //previewWeek  -> previewDayList: 학습자단 검색 전용
            this.previewWeek = res.data.previewDayList;
            this.previewTutor = res.data.previewTutor;
            this.previewLevel = res.data.previewLevel;
            this.totalStudent = res.data.totalStudent;
            this.totalWaitStudentCnt = res.data.totalWaitStudentCnt;

            // 등록된 클래스가 존재할 때 처음 클래스를 기본 클래스로 지정
            if (this.classList.length > 0) {
              this.classIdx = this.classList[0].idx;
            }

            if (
              this.program.subject_dup_type === "O" &&
              this.studentSubjectList.length > 0
            ) {
              this.classIdx = this.studentSubjectList[0].idxItmSugangClass;
              for (var [cIdx, classItem] of this.classList.entries()) {
                if (classItem.idx === this.classIdx) {
                  this.classNum = cIdx;
                  break;
                }
              }
            }

            for (let i = 0; i < this.classList.length; i++) {
              if (this.classList[i].class_name.length >= 14) {
                this.is_width = true;
                break;
              } else {
                this.is_width = false;
              }
            }

            // backend Response가 카멜, 스네이크 명명법이 섞여있어서 키값 파싱

            for (var item of this.subjectAllList) {
              var tempObj = {};

              for (var key in item) {
                // 언어 체크박스용 어레이 생성
                if (this.snakeToCamelCase(key) === "language") {
                  // this.language.push({
                  //     key: item[key],
                  //     value: false
                  // })
                }
                if (this.snakeToCamelCase(key) == "waitingNum") {
                  this.applyWaitCountNum += item[key];
                }
                if (this.snakeToCamelCase(key) == "faNum") {
                  if (item[key] === 0) {
                    this.applyWaitCountNum = 9999;
                  } else {
                    this.applyWaitCountNum += item[key];
                  }
                  console.log(this.applyWaitCountNum);
                }

                if (
                  this.snakeToCamelCase(key) == "applicantNum" ||
                  this.snakeToCamelCase(key) == "statusYCnt"
                ) {
                  this.applyWaitCountNum -= item[key];
                }

                if (this.snakeToCamelCase(key) === "place") {
                  // this.place.push({
                  //     key: item[key],
                  //     value: false
                  // })
                }

                tempObj[this.snakeToCamelCase(key)] = item[key];
              }
              this.subjectList.push(tempObj);
            }

            if (this.applyWaitCountNum < 1) {
              alert("신청인원이 가득 차 신청가능한 수업이 없습니다.");
              this.$router.push("/lnk/" + this.main.company_code);
            }

            var sugangList = [];
            var initClassIdx = this.classList[this.classNum].idx;
            for (var item of this.subjectList) {
              if (item.idxItmSugangClass === initClassIdx) {
                sugangList.push(item);
              }
              if (initClassIdx == -999) {
                sugangList.push(item);
              }
            }

            for (var [index, item] of this.classList.entries()) {
              this.selectList.push([]);
              for (var subject of this.subjectAllList) {
                if (item.idx === subject.idxItmSugangClass) {
                  this.selectList[0].push(false); //전체 데이터 삽입
                  this.selectList[index].push(false);
                }
              }
            }

            let selectSubjectIdx = [];
            // console.log("suganglist")
            for (var [index, subItem] of sugangList.entries()) {
              //console.log(subItem);
              for (var item of this.studentSubjectList) {
                if (
                  subItem.subjectIdx.toString() === item.idxItmSugangSubject
                ) {
                  if (
                    this.program.subject_dup_type === "X" ||
                    this.program.subject_dup_type === "N"
                  ) {
                    // console.log(subItem);
                    // selectSubjectIdx = subItem['subjectIdx']
                    selectSubjectIdx.push(subItem["idxItmSugangClass"]);
                  } else if (this.program.subject_dup_type === "O") {
                    subItem["notValid"] = true;
                  }
                  // A 타입은 notValid 설정하지 않음 (중복 가능)
                }
              }
            }
            // console.log(selectSubjectIdx);
            if (
              this.program.subject_dup_type === "X" ||
              this.program.subject_dup_type === "N"
            ) {
              // console.log(selectSubjectIdx);
              for (var [index, subItem] of sugangList.entries()) {
                // if(subItem['subjectIdx'] == selectSubjectIdx){
                // }
                // console.log(subItem['subjectIdx'])
                for (let i = 0; i < selectSubjectIdx.length; i++) {
                  if (subItem["idxItmSugangClass"] == selectSubjectIdx[i]) {
                    subItem["notValid"] = true;
                  }
                }
              }
            }

            for (let item of sugangList) {
              // 클래스 전체 선착순일때 세팅
              if (item.faType === "AF") {
                this.faMain.value = true;
                this.faMain.faNum = item.faNum;
                this.faMain.faType = item.faType;
                this.faMain.restYn = item.restYn;
                this.faMain.waitingNum = item.waitingNum;
                this.faMain.applicantNum = item.applicantNum;
                this.faMain.statusYCnt = item.statusYCnt;
                this.waitCountNum += item.statusYCnt;
                this.applyCountNum += item.applicantNum;

                // console.log('this.applyCountNum', this.applyCountNum)
              }

              // console.log('!!!!!item', item)
              for (let key in item) {
                // 언어 체크박스용 어레이 생성
                let count = 0;
                if (key === "language") {
                  for (var lang of this.language) {
                    if (lang.key === item[key]) {
                      count += 1;
                    }
                  }
                  if (count > 0) {
                    continue;
                  } else {
                    if (this.language.length < 20) {
                      this.language.push({
                        key: item[key],
                        value: false,
                      });
                    }
                  }
                }

                // 장소 체크박스용 어레이 생성
                if (key === "place") {
                  for (var pl of this.place) {
                    if (pl.key === item[key]) {
                      count += 1;
                    }
                  }
                  if (count > 0) {
                    continue;
                  } else {
                    if (this.place.length < 20) {
                      this.place.push({
                        key: item[key],
                        value: false,
                      });
                    }
                  }
                }

                // 요일 체크박스용 어레이 생성
                if (key === "day") {
                  let dyArr = item[key].split("^");
                  for (var dyVal of dyArr) {
                    for (var dy of this.weekday) {
                      if (dy.key === dyVal) {
                        count += 1;
                      }
                    }
                    if (count > 0) {
                      continue;
                    } else {
                      if (this.weekday.length < 20) {
                        this.weekday.push({
                          key: dyVal,
                          value: false,
                        });
                      }
                    }
                  }
                }

                //시간
                if (key === "subjectTime") {
                  const found = this.time.find(
                    (item) => item.key === item[key],
                  );
                  // console.log(this.time);
                  if (found === undefined) {
                    this.time.push({
                      key: item[key],
                      value: false,
                    });
                  }
                }

                if (key === "teacher") {
                  for (var tc of this.teacher) {
                    if (tc.key === item[key]) {
                      count += 1;
                    }
                  }
                  if (count > 0) {
                    continue;
                  } else {
                    if (this.teacher.length < 20 && item[key]) {
                      this.teacher.push({
                        key: item[key],
                        value: false,
                      });
                    }
                  }
                }

                if (key === "level") {
                  for (var lv of this.level) {
                    if (lv.key === item[key]) {
                      count += 1;
                    }
                  }
                  if (count > 0) {
                    continue;
                  } else {
                    if (this.level.length < 20) {
                      this.level.push({
                        key: item[key],
                        value: false,
                      });
                    }
                  }
                }
              }
            }

            // this.isBlocked = false
            // if (this.faMain.)

            // console.log('sugangList13312', sugangList)

            this.sugangList = JSON.parse(JSON.stringify(sugangList));

            //시간 중복 제거
            const copytime = [];
            for (let item of this.time) {
              const found = copytime.find(
                (copyitem) => copyitem.key === item.key,
              );
              if (!found) {
                copytime.push(item);
              }
            }
            this.time = copytime;
          } else {
            alert(res.data.result);
          }
        })
        .catch((err) => {
          console.log(err);
        });

      if (
        this.program.subject_dup_type_n_limit != 0 &&
        this.program.subject_dup_type_n_limit <
          this.checkBoxCheckNum +
            this.studentSubjectList.filter((item) => item.delStatus === "N")
              .length
      ) {
        alert(
          "최대 신청 가능 강의수는 " +
            this.program.subject_dup_type_n_limit +
            " 개 입니다\n현재 신청 되어있는 강의수 : " +
            this.studentSubjectList.filter((item) => item.delStatus === "N")
              .length,
        );
        return false;
      }
      if (this.main.limit_way === "P") {
        if (this.totalStudent >= this.main.limit_num) {
          if (this.main.wait_YN === "Y") {
            if (this.totalWaitStudentCnt >= this.main.wait_num) {
              alert("현재 수강신청 가능한 인원수 및 대기자수를 초과했습니다.");
              return false;
            } else {
              if (
                !confirm(
                  "" +
                    "현재 수강신청 가능한 인원수를 초과했습니다.\n" +
                    "수강신청 프로세스 진행 이후 대기열로 이동됩니다.",
                )
              ) {
                return false;
              }
            }
          } else if (this.main.wait_YN === "N") {
            alert("현재 수강신청 가능한 인원수를 초과했습니다.");
            return false;
          }
        }
      }

      if (this.paymentList.length === 0) {
        alert("선택하신 클래스가 없습니다.");
        return false;
      }

      // 총 결제금액이 0원인 경우에 결제 프로세스가 있는 경우에는 alert
      if (this.totalPayment === 0) {
        var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
        if (pOrder.includes("payment")) {
          alert(
            "결제 프로세스가 존재하고, 총 결제금액이 0원인 경우 결제가 불가능합니다.\n수강신청 제작시 결제 프로세스를 제외하고 만들어주세요.",
          );
          return false;
        }
      }

      let confirmArr = [];
      let confirm_msg = "선택하신 클래스를 확인해주세요.\n\n";
      if (
        this.paymentList[0].subjectName !== undefined &&
        this.paymentList[0].subjectName != ""
      )
        confirmArr.push("클래스명 : " + this.paymentList[0].subjectName);
      if (
        this.paymentList[0].subjectStartTime !== undefined &&
        this.paymentList[0].subjectStartTime != "" &&
        this.paymentList[0].subjectEndTime !== undefined &&
        this.paymentList[0].subjectEndTime != ""
      )
        confirmArr.push(
          "교육시간 : " +
            this.paymentList[0].subjectStartTime +
            " ~ " +
            this.paymentList[0].subjectEndTime,
        );
      if (
        this.paymentList[0].day !== undefined &&
        this.paymentList[0].day != ""
      )
        confirmArr.push(
          "요일 : " + this.paymentList[0].day.split("^").join(",") + "",
        );
      if (
        this.paymentList[0].place !== undefined &&
        this.paymentList[0].place != ""
      )
        confirmArr.push("교육장소 : " + this.paymentList[0].place);
      if (
        this.paymentList[0].teacher !== undefined &&
        this.paymentList[0].teacher != ""
      )
        confirmArr.push("강사 : " + this.paymentList[0].teacher);
      if (
        this.paymentList[0].level !== undefined &&
        this.paymentList[0].level != ""
      )
        confirmArr.push("레벨 : " + this.paymentList[0].level);
      confirm_msg += confirmArr.join("\n") + "\n";
      if (this.paymentList.length > 1)
        confirm_msg += "외 " + (this.paymentList.length - 1) + "강";

      if (confirm(confirm_msg)) {
        var count = 0;
        // 수강신청에 한 모든 수강이 대기자로 진행한 경우
        for (var payment of this.paymentList) {
          if (
            payment.faType === "SF" &&
            payment.faNum === payment.applicantNum
          ) {
            count += 1;
            continue;
          }
          if (payment.faType === "AF" && payment.faNum === this.applyCountNum) {
            count += 1;
            continue;
          }
        }

        if (count === this.paymentList.length) {
          var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
          if (pOrder.includes("payment")) {
            // alert('fesfesfes')
            sessionStorage.setItem("waitingPay", true);
            // return false
          }
        }

        var copyClassList = JSON.parse(JSON.stringify(this.classList));

        for (var payment of this.paymentList) {
          for (var list of copyClassList) {
            if (payment.idxItmSugangClass === list.idx) {
              if (list["subjectList"]) {
                list["subjectList"].push(payment);
              } else {
                list["subjectList"] = [];
                list["subjectList"].push(payment);
              }
            }
          }
        }

        var classList = [];
        var applyClassList = [];

        for (var item of copyClassList) {
          if (item["subjectList"]) {
            classList.push(item);
          }
        }

        for (var list of classList) {
          list["class_idx"] = list["idx"];
          delete list["idx"];

          var tempClassList = {};
          for (var item in list) {
            tempClassList[this.snakeToCamelCase(item)] = list[item];
          }

          applyClassList.push(tempClassList);
        }

        var tempClassData = {
          classList: applyClassList,
          totalPayment: this.totalPayment,
        };

        if (sessionStorage.getItem("classData")) {
          var sessionData = JSON.parse(sessionStorage.getItem("classData"));
          if (sessionData.info) {
            tempClassData = sessionData;
            tempClassData["classList"] = applyClassList;
            tempClassData["totalPayment"] = this.totalPayment;
            tempClassData["info"] = sessionData.info;
          }
        }

        sessionStorage.setItem("classData", JSON.stringify(tempClassData));

        var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
        var idx = pOrder.indexOf("select") + 1;

        // 대기자로 수강신청하는데 다음 페이지가 결제페이지인 경우
        if (sessionStorage.getItem("waitingPay") && pOrder[idx] === "payment") {
          this.isRegPage = true;
          this.save();
          return false;
        }

        if (this.isFinishPage || this.isRegPage) {
          this.save();
        } else {
          var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
          var idx = pOrder.indexOf("select") + 1;
          sessionStorage.setItem("step", pOrder[idx]);
          this.$router.push(`/user/reg/${pOrder[idx]}`);
        }
      } else {
        return false;
      }
    },

    // 수강신청 전체 데이터 저장
    save() {
      var classData = JSON.parse(sessionStorage.getItem("classData"));

      classData["idxItmSugangPageMain"] = sessionStorage.getItem("pageIdx");

      classData["payStatus"] = "X";

      var itemNames = [
        "이름",
        "비밀번호",
        "사번",
        "휴대전화번호",
        "직급",
        "부서",
        "회사",
        "공인시험점수",
      ];
      var count = 1;

      for (var item of classData["info"]) {
        if (item.item_name.includes("E-mail@")) {
          continue;
        } else if (itemNames.includes(item.item_name)) {
          continue;
        } else {
          classData["optionName" + count.toString()] = item.item_name;
          classData["optionContents" + count.toString()] = item.value;
          count += 1;
        }
      }

      delete classData["info"];

      classData["type"] = "Y";
      classData["studentSubjectIdx"] = -1;
      if (classData.classList) {
        classData["programIdx"] = sessionStorage.getItem("programIdx");
        delete classData["totalPayment"];
      } else {
        classData["type"] = "N";
        classData["orderId"] = "";
        classData["classList"] = [];
      }

      let params = classData;

      /// 체크
      /*this.axios
            .post(this.axios.root + this.axios.port + "/user/check-subjectdup", params)
            .then((res) => {
              if (!res.data.err === 0) {
                alert(res.data.result)
                return false
              }
            })*/

      /// 수강신청 정보 밀어넣기
      this.axios
        .post(this.axios.root + this.axios.port + "/user/apply", params)
        .then((res) => {
          // console.log("최종 저장 res", res);
          localStorage.setItem("accessToken", res.data.accessToken);
          this.axios.defaults.headers.common["accessToken"] =
            res.data.accessToken;
          if (res.data.err === 0) {
            if (res.data.subjectList) {
              sessionStorage.setItem(
                "finishData",
                JSON.stringify(res.data.subjectList),
              );
            }
            alert("수강신청이 완료되었습니다.");
            if (this.isFinishPage) {
              this.$router.push("/user/applyList");
            } else if (this.isRegPage) {
              var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
              if (pOrder[pOrder.length - 1] === "complete") {
                this.$router.push("/user/reg/complete");
              } else {
                this.$router.push("/user/applyList");
              }
            }
          } else {
            alert(res.data.result);
            return false;
          }
        });
    },

    // 전체클래스 상세보기 윈도우 팝업 열기
    // 파일 위치는 components/reg/detail.vue
    openPopup() {
      let routeData = this.$router.resolve({
        name: "reg-apply-detail",
        query: {
          programIdx: sessionStorage.getItem("programIdx"),
        },
      });
      window.open(
        routeData.href,
        "window팝업",
        "width=1200, height=650, top:100, left:100, menubar=no, status=no, toolbar=no",
      );
    },
    // 클래스 상세보기 레이어팝업 열기
    openModal(data) {
      this.parentData = data;
      this.isDetailModalOpened = true;
    },

    // 모달 닫기
    closeModal() {
      this.isDetailModalOpened = false;
    },

    // 신청내역 확인 페이지로 이동
    moveApplyList() {
      this.$router.push("/user/applyList");
    },

    logout() {
      /* localStorage.removeItem('userId')
            localStorage.removeItem('accessToken')
            delete this.axios.defaults.headers.common['accessToken']
            var tempCompanyCode = sessionStorage.getItem('companyCode')
            sessionStorage.clear()
            sessionStorage.setItem('companyCode', tempCompanyCode)
            웹취약점 */
      this.axios
        .get(this.axios.root + this.axios.port + "/login/out")
        .then((res) => {
          if (res.data.err === 0) {
            localStorage.removeItem("userId");
            localStorage.removeItem("accessToken");
            delete this.axios.defaults.headers.common["accessToken"];
            var tempCompanyCode = sessionStorage.getItem("companyCode");
            sessionStorage.clear();
            sessionStorage.setItem("companyCode", tempCompanyCode);
            alert("로그아웃 되었습니다.");
            this.$router.push("/user/login");
          }
        });
    },
  },
};
</script>
